import React from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { IFilter } from "@formant/core/model/IFilter";
import { useMemoByValue } from "@formant/ui/hooks/useMemoByValue";

import { useStores } from "../../../context/StoreContext";
import {
    SeekOption,
    seekOptions,
    seekOptionToEventTypes,
} from "../../../store/SeekOption";
import { Select } from "../../common/Select";
import * as styles from "./SeekOptionSelect.scss";

export interface IFilterSeekSelect {
    filter: IFilter;
    seekOption: SeekOption;
    onChange: (seekOption: SeekOption) => void;
    className: string;
}

function seekOptionToClassName(_: SeekOption): string {
    switch (_) {
        case "Comments":
            return "comment";
        case "Annotations":
            return "annotation";
        case "Commands":
            return "command";
        case "Data presence":
            return "presence";
        case "Notifications":
            return "other";
        case "All other events":
            return "other";
    }
}

function seekOptionToChipStyle(_: SeekOption): string {
    return styles[seekOptionToClassName(_)];
}

export const SeekOptionSelect = observer(function SeekOptionSelect(
    props: IFilterSeekSelect,
) {
    const { filter, onChange, className } = props;
    const { eventStore } = useStores();

    const existingEventTypes = eventStore.eventTypes(filter);

    const options = useMemoByValue(
        () =>
            seekOptions.filter(
                _ =>
                    _ === "Data presence" ||
                    seekOptionToEventTypes(_).some(seekOptionEventType =>
                        existingEventTypes?.includes(seekOptionEventType),
                    ),
            ),
        [existingEventTypes],
    );

    let { seekOption } = props;
    if (!options.includes(seekOption)) {
        seekOption = "Data presence";
    }

    const lineButtonClassName = styles[seekOptionToClassName(seekOption)];
    return (
        <Select
            value={seekOption}
            options={options}
            icon="seek-option"
            bottom={true}
            title="Seek by"
            responsive={true}
            onChange={onChange}
            className={classnames(styles["seek-option-select"], className)}
            lineButtonClassName={lineButtonClassName}
            chipClassName={seekOptionToChipStyle}
        />
    );
});
